import React from 'react';
import { withRouter } from '../../common/withRouter';
import { connect } from 'react-redux';
import { ButtonOBSOLETED as Button, Notification } from '../../web.common';
import { Message } from '../../web.common/src/components/lists/SystemMessages';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';

class ChecksInternal extends React.Component {
  constructor() {
    super();

    this.state = {
      errorMessage: null
    };
  }

  render() {
    return (
      <LayoutContext.Consumer>
        {() => {
          const { api } = this.props;
          const {
            errorMessage,
            executingBookingsCheck,
            output
          } = this.state;

          const {
            checks: {
              bookings,
            }
          } = api;

          return (
            <div className='content-width-limiter-narrow'>
              <Notification newMessage={errorMessage} />
              <PageTop
                documentTitle='Checks page'
                documentDescription='Checks page'
              />
              <br />
              <br />
              <Button
                disabled={executingBookingsCheck}
                onClick={async () => {
                  this.setState({
                    executingBookingsCheck: true
                  });

                  try {
                    const result = await bookings();
                    this.setState({
                      output: result,
                      executingBookingsCheck: false,
                      errorMessage: new Message('success', 'Done')
                    });
                  }
                  catch (e) {
                    this.setState({
                      output: JSON.stringify(e),
                      executingBookingsCheck: false,
                      errorMessage: new Message('error', JSON.stringify(e))
                    });
                    return;
                  }
                }}
                type='button'
                className='button button-primary button-full-width'
                buttonContent='Check external purchases'
                ariaLabel='rebuild Products index'
              />
              <br />
              <br />
              <div>{output}</div>
            </div>
          );
        }}
      </LayoutContext.Consumer>
    );
  }
}

const Checks = withApi(withRouter(
  connect(({ user }) => ({ isLoggedIn: !!user, user }), {})(ChecksInternal)));
Checks.requiresLogin = true;

export default Checks;